export const validateIconPosition = (value) => {
    return ['right', 'left'].includes(value);
};

export const validateButtonSize = (value) => {
    return ['small', 'medium', 'large'].includes(value);
};
